import { NgxMatDateAdapter, NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular-material-components/moment-adapter';
import { NgModule } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { NgxMatSelectSearchModule } from 'src/vendor/mat-select-search/ngx-mat-select-search.module';
import { AppService } from '../app.service';
import { CustomDatePickerAdapter, CUSTOM_DATE_FORMATS } from './date-adapter';

/**
 * Модель для подключения модулей материал дизайна
 */
@NgModule({
    imports: [
        MatButtonModule,
        MatCardModule,
        MatDialogModule,
        MatInputModule,
        MatTableModule,
        MatToolbarModule,
        MatGridListModule,
        MatIconModule,
        MatTabsModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatSelectModule,
        MatOptionModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatFormFieldModule,
        MatProgressSpinnerModule,
        NgxMatSelectSearchModule,
        MatMenuModule,
        MatButtonToggleModule,
        MatTreeModule,
        MatDividerModule,
        MatTooltipModule,
        MatListModule,
        MatSidenavModule,
        MatExpansionModule,
        MatRadioModule,
        MatProgressBarModule,
        NgxMatDatetimePickerModule,
        MatSliderModule,
    ],
    exports: [
        MatButtonModule,
        MatCardModule,
        MatDialogModule,
        MatInputModule,
        MatTableModule,
        MatToolbarModule,
        MatGridListModule,
        MatIconModule,
        MatTabsModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatSelectModule,
        MatOptionModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatProgressSpinnerModule,
        NgxMatSelectSearchModule,
        MatMenuModule,
        MatButtonToggleModule,
        MatTreeModule,
        MatDividerModule,
        MatTooltipModule,
        MatListModule,
        MatSidenavModule,
        MatExpansionModule,
        MatRadioModule,
        MatProgressBarModule,
        NgxMatDatetimePickerModule,
        MatSliderModule,
    ],
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
        { provide: MAT_DATE_LOCALE, deps: [AppService], useFactory: getLanguage },
        { provide: DateAdapter, useClass: CustomDatePickerAdapter, deps: [MAT_DATE_LOCALE] },
        {
            provide: NgxMatDateAdapter,
            useClass: CustomDatePickerAdapter,
            deps: [MAT_DATE_LOCALE, NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
    ],
})
export class CustomMaterialModule {}

export const langLocale = ['ru', 'en', 'de'];

export function getLanguage(appService: AppService) {
    return langLocale.indexOf(appService.currentLanguage) != -1 ? appService.currentLanguage : 'ru';
}
